// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const CLEAN = '@auth/CLEAN';
export const REGISTER = '@auth/REGISTER';
export const LOAD_CONTACTS = '@load/CONTACTS';
export const LOAD_APPLICATIONS = '@load/APPLICATIONS';
